export const REQUEST_CREATE_SESSION = 'REQUEST_CREATE_SESSION';
export const RECEIVE_CREATE_SESSION = 'RECEIVE_CREATE_SESSION';
export const SET_CREATE_SESSION_FAILURE = 'SET_CREATE_SESSION_FAILURE';
export const CLEAR_CREATE_SESSION_ERROR_MESSAGE = 'CLEAR_CREATE_SESSION_ERROR_MESSAGE';
